import React from 'react';
import Select from 'react-select';

function OrgCard({
  userName,
  orgOptions,
  selectedOrg,
  onOrgChange,
  onProcess,
  onLogout,
  disableProcess = false
}) {
  return (
    <div className="card shadow p-4">
      <h3 className="mb-3">Welcome, {userName}</h3>
      <p className="text-muted">You are now logged in to the Suyog ERP Dashboard.</p>

      <div className="mb-4">
        <label className="form-label">Select Organization</label>
        <Select
          options={orgOptions}
          value={selectedOrg}
          onChange={onOrgChange}
          placeholder="Choose organization..."
          isClearable
        />
      </div>

      <div className="d-flex justify-content-between">
        <button
          className="btn btn-primary"
          disabled={disableProcess || !selectedOrg}
          onClick={onProcess}
        >
          Let's Process, Ready to Work
        </button>

        <button
          className="btn btn-danger"
          onClick={onLogout}
        >
          Logout
        </button>
      </div>
    </div>
  );
}

export default OrgCard;
